$(document).ready(function () {

    var $ajaxForms = $('.js-ajax_form');

    var formContentClassSelector = '.js-ajax_form__content';

    if (typeof $ajaxForms !== 'undefined' && $ajaxForms.length > 0) {
        $ajaxForms.each(function (i, e) {
            var $wrapper = $(e);
            var content = $wrapper.find(formContentClassSelector).data('content');

            $(this).find('form').on('submit', function (e) {
                e.preventDefault();
                var $form = $(this);

                if ($form.data('submitted') === true) {
                    // prevent double submission
                } else {
                    if ($form.valid()) {
                        $form.data('submitted', true);

                        var formData = new FormData(this);

                        $.ajax({
                            url: $form.attr('action'),
                            type: 'POST',
                            cache: false,
                            data: formData,
                            processData: false,
                            contentType:false,
                            success: function (result) {
                                $form.html('<p>' + content + '</p>');
                            },
                            error: function (error) {
                                console.log(error);
                            }
                        });
                    }
                }
            });
        });
    }
});